// Build a variant SKU from a parent item + chosen color + size.
// NetSuite matrix items typically use child item names like
// `PARENT-COLOR-SIZE`. This helper is the single place that mapping lives;
// if your matrix naming convention differs, change it here only.

export function variantSku(item, color, size) {
  if (!item) return null;
  const parts = [item.sku || item.id];
  if (color?.id) parts.push(String(color.id).toUpperCase());
  if (size) parts.push(String(size).toUpperCase());
  return parts.filter(Boolean).join("-");
}
